// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Backdrop ────────────────────────────────────────────── */
.br-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(3px);
    z-index: 9990;
    animation: br-fade-in 0.18s ease;
}

@keyframes br-fade-in {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* ── Panel — centered modal ──────────────────────────────── */
.br-panel {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9991;
    width: 480px;
    max-width: calc(100vw - 32px);
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    background: #111114;
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 20px;
    box-shadow:
        0 32px 80px rgba(0, 0, 0, 0.7),
        0 0 0 1px rgba(255, 255, 255, 0.03);
    animation: br-slide-up 0.22s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes br-slide-up {
    from { opacity: 0; transform: translate(-50%, calc(-50% + 16px)); }
    to   { opacity: 1; transform: translate(-50%, -50%); }
}

/* ── Panel header ────────────────────────────────────────── */
.br-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 24px 0;
    position: sticky;
    top: 0;
    background: #111114;
    z-index: 1;
}

.br-panel__heading {
    display: flex;
    align-items: center;
    gap: 10px;
}

.br-panel__heading-icon {
    width: 20px;
    height: 20px;
    color: #c0a053;
    flex-shrink: 0;
}

.br-panel__title {
    font-size: 1rem;
    font-weight: 600;
    color: #f0f0f0;
    margin: 0;
    letter-spacing: 0.01em;
}

.br-panel__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    color: #707070;
    font-size: 1.1rem;
    line-height: 1;
    cursor: pointer;
    transition: all 0.15s ease;
    font-family: inherit;
    flex-shrink: 0;
}

.br-panel__close:hover {
    background: rgba(255, 255, 255, 0.09);
    border-color: rgba(255, 255, 255, 0.14);
    color: #d0d0d0;
}

/* ── Form ────────────────────────────────────────────────── */
.br-form {
    padding: 20px 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.br-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.br-label {
    font-size: 0.6875rem;
    font-weight: 700;
    color: #666;
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.br-label--opt {
    font-weight: 400;
    text-transform: none;
    color: #484848;
    letter-spacing: 0;
    font-size: 0.6875rem;
}

/* ── Type toggle ─────────────────────────────────────────── */
.br-type-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.br-type-btn {
    padding: 10px 8px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(255, 255, 255, 0.03);
    color: #787878;
    font-size: 0.8125rem;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s ease;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}

.br-type-btn:hover {
    border-color: rgba(255, 255, 255, 0.13);
    color: #c0c0c0;
    background: rgba(255, 255, 255, 0.055);
}

.br-type-btn--active {
    border-color: rgba(192, 159, 83, 0.45);
    background: rgba(192, 159, 83, 0.08);
    color: #e8d9b0;
}

.br-type-btn__icon {
    font-size: 1.1rem;
    line-height: 1;
}

/* ── Inputs ──────────────────────────────────────────────── */
.br-input {
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 10px;
    padding: 10px 13px;
    color: #e0e0e0;
    font-size: 0.875rem;
    font-family: inherit;
    line-height: 1.5;
    outline: none;
    transition: border-color 0.15s ease, background 0.15s ease;
    width: 100%;
    box-sizing: border-box;
}

.br-input::placeholder {
    color: #3a3a3a;
}

.br-input:focus {
    border-color: rgba(192, 159, 83, 0.4);
    background: rgba(255, 255, 255, 0.055);
}

.br-input--textarea {
    resize: vertical;
    min-height: 90px;
}

/* ── Divider ─────────────────────────────────────────────── */
.br-divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.06);
    margin: 0 -24px;
}

/* ── Meta note ───────────────────────────────────────────── */
.br-meta {
    font-size: 0.6875rem;
    color: #404040;
    margin: 0;
    line-height: 1.5;
    display: flex;
    align-items: center;
    gap: 5px;
}

.br-meta::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #404040;
    flex-shrink: 0;
}

/* ── Error ───────────────────────────────────────────────── */
.br-error {
    font-size: 0.8rem;
    color: #ff8080;
    background: rgba(255, 80, 80, 0.07);
    border: 1px solid rgba(255, 80, 80, 0.18);
    border-radius: 10px;
    padding: 10px 13px;
    margin: 0;
    line-height: 1.4;
}

/* ── Actions ─────────────────────────────────────────────── */
.br-actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding-top: 2px;
}

.br-btn {
    padding: 10px 20px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: rgba(255, 255, 255, 0.04);
    color: #888;
    font-size: 0.875rem;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s ease;
}

.br-btn:hover {
    background: rgba(255, 255, 255, 0.08);
    color: #c0c0c0;
    border-color: rgba(255, 255, 255, 0.16);
}

.br-btn--primary {
    border-color: rgba(192, 159, 83, 0.45);
    background: linear-gradient(160deg, rgba(192, 159, 83, 0.2) 0%, rgba(150, 120, 50, 0.12) 100%);
    color: #f0e4c0;
    font-weight: 600;
}

.br-btn--primary:hover:not(:disabled) {
    border-color: rgba(192, 159, 83, 0.7);
    background: linear-gradient(160deg, rgba(192, 159, 83, 0.3) 0%, rgba(150, 120, 50, 0.2) 100%);
    color: #faf0d8;
}

.br-btn--primary:disabled {
    opacity: 0.35;
    cursor: not-allowed;
}

/* ── Success ─────────────────────────────────────────────── */
.br-success {
    padding: 32px 24px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
    animation: br-fade-in 0.2s ease;
}

.br-success__ring {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: rgba(100, 200, 130, 0.1);
    border: 1px solid rgba(100, 200, 130, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;
}

.br-success__icon {
    width: 28px;
    height: 28px;
    color: #7dd69e;
}

.br-success__msg {
    font-size: 1rem;
    font-weight: 600;
    color: #f0f0f0;
    margin: 0;
}

.br-success__sub {
    font-size: 0.8125rem;
    color: #686868;
    margin: 0;
    line-height: 1.55;
    max-width: 280px;
}

/* ── Trigger ─────────────────────────────────────────────── */
.br-root {
    position: fixed;
    bottom: 20px;
    right: 80px;
    z-index: 9989;
    font-family: inherit;
}

.br-trigger {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 9px 16px;
    background: rgba(14, 14, 18, 0.92);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 22px;
    cursor: pointer;
    font-family: inherit;
    font-size: 0.75rem;
    font-weight: 500;
    color: #909090;
    backdrop-filter: blur(12px);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4), 0 1px 0 rgba(255,255,255,0.04) inset;
    transition: border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.br-trigger:hover {
    border-color: rgba(255, 255, 255, 0.18);
    color: #c8c8c8;
    box-shadow: 0 6px 28px rgba(0, 0, 0, 0.5), 0 1px 0 rgba(255,255,255,0.05) inset;
}

.br-trigger--active {
    border-color: rgba(192, 159, 83, 0.4);
    color: #d4c090;
}

.br-trigger__icon {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
    color: currentColor;
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/Components/BugReport/BugReport.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA,+DAA+D;AAC/D;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB;;2CAEuC;IACvC,2DAA2D;AAC/D;;AAEA;IACI,OAAO,UAAU,EAAE,6CAA6C,EAAE;IAClE,OAAO,UAAU,EAAE,gCAAgC,EAAE;AACzD;;AAEA,+DAA+D;AAC/D;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,cAAc;AAClB;;AAEA,+DAA+D;AAC/D;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA,+DAA+D;AAC/D;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,uCAAuC;IACvC,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,+DAA+D;AAC/D;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,0DAA0D;IAC1D,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,+DAA+D;AAC/D;IACI,WAAW;IACX,qCAAqC;IACrC,eAAe;AACnB;;AAEA,+DAA+D;AAC/D;IACI,oBAAoB;IACpB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,+DAA+D;AAC/D;IACI,iBAAiB;IACjB,cAAc;IACd,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA,+DAA+D;AAC/D;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,sCAAsC;IACtC,8FAA8F;IAC9F,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,6FAA6F;IAC7F,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,+DAA+D;AAC/D;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,+DAA+D;AAC/D;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kCAAkC;IAClC,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,+EAA+E;IAC/E,yEAAyE;AAC7E;;AAEA;IACI,uCAAuC;IACvC,cAAc;IACd,+EAA+E;AACnF;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":["/* ── Backdrop ────────────────────────────────────────────── */\n.br-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(3px);\n    z-index: 9990;\n    animation: br-fade-in 0.18s ease;\n}\n\n@keyframes br-fade-in {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n}\n\n/* ── Panel — centered modal ──────────────────────────────── */\n.br-panel {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 9991;\n    width: 480px;\n    max-width: calc(100vw - 32px);\n    max-height: calc(100vh - 80px);\n    overflow-y: auto;\n    background: #111114;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    border-radius: 20px;\n    box-shadow:\n        0 32px 80px rgba(0, 0, 0, 0.7),\n        0 0 0 1px rgba(255, 255, 255, 0.03);\n    animation: br-slide-up 0.22s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes br-slide-up {\n    from { opacity: 0; transform: translate(-50%, calc(-50% + 16px)); }\n    to   { opacity: 1; transform: translate(-50%, -50%); }\n}\n\n/* ── Panel header ────────────────────────────────────────── */\n.br-panel__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 22px 24px 0;\n    position: sticky;\n    top: 0;\n    background: #111114;\n    z-index: 1;\n}\n\n.br-panel__heading {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.br-panel__heading-icon {\n    width: 20px;\n    height: 20px;\n    color: #c0a053;\n    flex-shrink: 0;\n}\n\n.br-panel__title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #f0f0f0;\n    margin: 0;\n    letter-spacing: 0.01em;\n}\n\n.br-panel__close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 8px;\n    color: #707070;\n    font-size: 1.1rem;\n    line-height: 1;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    font-family: inherit;\n    flex-shrink: 0;\n}\n\n.br-panel__close:hover {\n    background: rgba(255, 255, 255, 0.09);\n    border-color: rgba(255, 255, 255, 0.14);\n    color: #d0d0d0;\n}\n\n/* ── Form ────────────────────────────────────────────────── */\n.br-form {\n    padding: 20px 24px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.br-field {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.br-label {\n    font-size: 0.6875rem;\n    font-weight: 700;\n    color: #666;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n}\n\n.br-label--opt {\n    font-weight: 400;\n    text-transform: none;\n    color: #484848;\n    letter-spacing: 0;\n    font-size: 0.6875rem;\n}\n\n/* ── Type toggle ─────────────────────────────────────────── */\n.br-type-row {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n}\n\n.br-type-btn {\n    padding: 10px 8px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(255, 255, 255, 0.03);\n    color: #787878;\n    font-size: 0.8125rem;\n    font-weight: 500;\n    font-family: inherit;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 5px;\n}\n\n.br-type-btn:hover {\n    border-color: rgba(255, 255, 255, 0.13);\n    color: #c0c0c0;\n    background: rgba(255, 255, 255, 0.055);\n}\n\n.br-type-btn--active {\n    border-color: rgba(192, 159, 83, 0.45);\n    background: rgba(192, 159, 83, 0.08);\n    color: #e8d9b0;\n}\n\n.br-type-btn__icon {\n    font-size: 1.1rem;\n    line-height: 1;\n}\n\n/* ── Inputs ──────────────────────────────────────────────── */\n.br-input {\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    border-radius: 10px;\n    padding: 10px 13px;\n    color: #e0e0e0;\n    font-size: 0.875rem;\n    font-family: inherit;\n    line-height: 1.5;\n    outline: none;\n    transition: border-color 0.15s ease, background 0.15s ease;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.br-input::placeholder {\n    color: #3a3a3a;\n}\n\n.br-input:focus {\n    border-color: rgba(192, 159, 83, 0.4);\n    background: rgba(255, 255, 255, 0.055);\n}\n\n.br-input--textarea {\n    resize: vertical;\n    min-height: 90px;\n}\n\n/* ── Divider ─────────────────────────────────────────────── */\n.br-divider {\n    height: 1px;\n    background: rgba(255, 255, 255, 0.06);\n    margin: 0 -24px;\n}\n\n/* ── Meta note ───────────────────────────────────────────── */\n.br-meta {\n    font-size: 0.6875rem;\n    color: #404040;\n    margin: 0;\n    line-height: 1.5;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.br-meta::before {\n    content: '';\n    display: inline-block;\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: #404040;\n    flex-shrink: 0;\n}\n\n/* ── Error ───────────────────────────────────────────────── */\n.br-error {\n    font-size: 0.8rem;\n    color: #ff8080;\n    background: rgba(255, 80, 80, 0.07);\n    border: 1px solid rgba(255, 80, 80, 0.18);\n    border-radius: 10px;\n    padding: 10px 13px;\n    margin: 0;\n    line-height: 1.4;\n}\n\n/* ── Actions ─────────────────────────────────────────────── */\n.br-actions {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-end;\n    padding-top: 2px;\n}\n\n.br-btn {\n    padding: 10px 20px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    background: rgba(255, 255, 255, 0.04);\n    color: #888;\n    font-size: 0.875rem;\n    font-weight: 500;\n    font-family: inherit;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.br-btn:hover {\n    background: rgba(255, 255, 255, 0.08);\n    color: #c0c0c0;\n    border-color: rgba(255, 255, 255, 0.16);\n}\n\n.br-btn--primary {\n    border-color: rgba(192, 159, 83, 0.45);\n    background: linear-gradient(160deg, rgba(192, 159, 83, 0.2) 0%, rgba(150, 120, 50, 0.12) 100%);\n    color: #f0e4c0;\n    font-weight: 600;\n}\n\n.br-btn--primary:hover:not(:disabled) {\n    border-color: rgba(192, 159, 83, 0.7);\n    background: linear-gradient(160deg, rgba(192, 159, 83, 0.3) 0%, rgba(150, 120, 50, 0.2) 100%);\n    color: #faf0d8;\n}\n\n.br-btn--primary:disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n}\n\n/* ── Success ─────────────────────────────────────────────── */\n.br-success {\n    padding: 32px 24px 32px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 12px;\n    animation: br-fade-in 0.2s ease;\n}\n\n.br-success__ring {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    background: rgba(100, 200, 130, 0.1);\n    border: 1px solid rgba(100, 200, 130, 0.25);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 4px;\n}\n\n.br-success__icon {\n    width: 28px;\n    height: 28px;\n    color: #7dd69e;\n}\n\n.br-success__msg {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #f0f0f0;\n    margin: 0;\n}\n\n.br-success__sub {\n    font-size: 0.8125rem;\n    color: #686868;\n    margin: 0;\n    line-height: 1.55;\n    max-width: 280px;\n}\n\n/* ── Trigger ─────────────────────────────────────────────── */\n.br-root {\n    position: fixed;\n    bottom: 20px;\n    right: 80px;\n    z-index: 9989;\n    font-family: inherit;\n}\n\n.br-trigger {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    padding: 9px 16px;\n    background: rgba(14, 14, 18, 0.92);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 22px;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: #909090;\n    backdrop-filter: blur(12px);\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4), 0 1px 0 rgba(255,255,255,0.04) inset;\n    transition: border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.br-trigger:hover {\n    border-color: rgba(255, 255, 255, 0.18);\n    color: #c8c8c8;\n    box-shadow: 0 6px 28px rgba(0, 0, 0, 0.5), 0 1px 0 rgba(255,255,255,0.05) inset;\n}\n\n.br-trigger--active {\n    border-color: rgba(192, 159, 83, 0.4);\n    color: #d4c090;\n}\n\n.br-trigger__icon {\n    width: 15px;\n    height: 15px;\n    flex-shrink: 0;\n    color: currentColor;\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
